import {OpenFeature} from '@openfeature/web-sdk';
import {ConfigCatWebProvider} from '@openfeature/config-cat-web-provider';
import {createConsoleLogger, LogLevel} from "configcat-js-ssr";

let currentConfigContext = null;
let configClient = null;
let hasWarnedUninitialized = false;

export async function initConfigClient(sdkKey, hooksHandler, context, baseUrl) {
    if (configClient) {
        return;
    }

    let useSdkKey = sdkKey;

    /**
     * The ConfigCat SDK validates the format of the sdk key.
     *
     * Even when using a custom proxy, it validates that the sdk key
     * provided at least starts with config-cat-proxy/.  If a base URL is passed,
     * assume we are sending this to the forward endpoint.  In that case, we don't
     * need a real sdk key here, so let's pass one that always passes validation.
     */
    if (baseUrl) {
      useSdkKey = 'configcat-proxy/key';
    }

    const options = {
        logger: createConsoleLogger(LogLevel.Off), // should not be enabled in prod environments
        baseUrl: baseUrl
    }

    if (hooksHandler) {
        options.setupHooks = hooksHandler;
    }

   try {
        await OpenFeature.setProviderAndWait(ConfigCatWebProvider.create(useSdkKey, options));
        if (context) {
            currentConfigContext = context;
            await OpenFeature.setContext(currentConfigContext);
        }
        configClient = OpenFeature.getClient();
        return configClient;
    } catch (error) {
        console.error('Failed to initialize config client:', error);
    }
}

export function hasConfig() {
    return !!configClient;
}

export function getConfigBooleanValue(key, defaultValue = false) {
    if (!configClient) {
        if (!hasWarnedUninitialized) {
            console.warn('Config client is not initialized. Returning default value for key:', key);
            hasWarnedUninitialized = true;
        }
        return defaultValue;
    }
    return configClient.getBooleanValue(key, defaultValue, currentConfigContext);
}

export function getConfigClient() {
    return configClient;
}

export function getConfigContext() {
    return currentConfigContext;
}
